export default {
      id: "arrow-left-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }